import { Button, Result } from 'antd';
import styled from 'styled-components';

import { tokens } from '~/styles/tokens';

export const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: ${tokens.colors.background};
`;

export const StyledResult = styled(Result)`
  .ant-result-title {
    color: #ff4d4f;
    font-size: 24px;
    font-weight: 500;
  }

  .ant-result-subtitle {
    color: ${tokens.colors.text};
    margin-top: 8px;
  }
`;

export const RetryButton = styled(Button)`
  min-width: 120px;
  height: 40px;

  &:hover {
    opacity: 0.9;
  }
`;
